import isInSubdomain from './isInSubdomain'

export default function isMainDomain() {
  return isInSubdomain('web', 'www', 'support', '')
}
